import { Box } from "@mui/material";
import FileUpload from "./FileUpload";
import FieldMapping from "./FieldMapping";
import MapFields from "./MapFields";
import TestMatch from "./TestMatch";

const sx = {
  root: {
    color: "darkBlue.c100"
  }
};

export default function FileValidationMain({
  fieldMappingRows,
  loading,
  fileName,
  showFileName,
  disableFileUpload,
  mappedData,
  hasHeaderRow,
  testMatchData,
  testMatchLoading,
  loadData,
  showAlert,
  showFileAlert,
  showRunTestError,
  mappedDataLoading,
  fileLoading,
  onFileSelect,
  onFieldChange,
  onUpdate,
  onRemove,
  onDownload,
  onShowMappedData,
  onHeaderRowChange,
  onReset,
  onClearAll,
  onRunMatch,
  onAlertClose
}) {
  return (
    <Box sx={sx.root}>
      <FileUpload
        showFileName={showFileName}
        fileLoading={fileLoading}
        fileName={fileName}
        disableFileUpload={disableFileUpload}
        showFileAlert={showFileAlert}
        onFileSelect={onFileSelect}
        onRemove={onRemove}
        onDownload={onDownload}
        onAlertClose={onAlertClose}
      />
      <FieldMapping
        loading={loading}
        fieldMappingRows={fieldMappingRows}
        showAlert={showAlert}
        hasHeaderRow={hasHeaderRow}
        onFieldChange={onFieldChange}
        onUpdate={onUpdate}
        onHeaderRowChange={onHeaderRowChange}
        onReset={onReset}
        onClearAll={onClearAll}
        onAlertClose={onAlertClose}
      />
      <MapFields
        rows={mappedData.rows}
        mappedDataLoading={mappedDataLoading}
        loadData={loadData}
        fieldMappingRows={fieldMappingRows}
        isError={mappedData.isError}
        errorMsg={mappedData.msg}
        onShow={onShowMappedData}
        onAlertClose={onAlertClose}
      />
      <TestMatch
        loading={testMatchLoading}
        fieldMappingRows={fieldMappingRows}
        showRunTestError={showRunTestError}
        isFileUploaded={disableFileUpload}
        data={testMatchData}
        loadData={loadData}
        onRunMatch={onRunMatch}
        isError={mappedData.isError}
        onAlertClose={onAlertClose}
        showAlert={showAlert}
      />
    </Box>
  );
}
